<div
  class="relative flex bg-[#e3e3e3]/60 dark:bg-[#1c1c1c]/60 rounded-full shadow"
  [ngClass]="{ ' flex-row gap-4 px-4 py-2': !col, ' flex-col gap-2  px-1 py-2': col }"
>
  @if (isAutoRotate) {
    <div>
      <button
        class="w-6 h-6 lg:w-10 lg:h-10 rounded-full p-0.5 lg:p-1.5 text-black/50 dark:text-white/50 hover:text-black/80 dark:hover:text-white/80"
        [ngClass]="{
          'bg-none': !isAutoRotation,
          ' bg-white dark:bg-black': isAutoRotation,
        }"
        (click)="onClickAutoRotation()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 30" fill="none">
          <path
            d="M18.1335 21.0242V27.5938C18.1335 28.3891 18.9469 28.8971 19.6142 28.5161L25.3078 25.2346C26.0005 24.8336 26.0005 23.7911 25.3078 23.3967L19.6142 20.1153C18.9469 19.721 18.1335 20.2289 18.1335 21.0242Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M32.9462 10.9927C36.9432 12.3828 39.4723 14.4346 39.4723 16.7269C39.4723 19.1663 36.6255 21.3317 32.2027 22.7084C30.3155 23.3032 28.1422 23.751 25.7847 24.0183"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.40477 10.9927C4.40777 12.3828 1.87866 14.4346 1.87866 16.7269C1.87866 19.1663 4.72549 21.3317 9.14825 22.7084C11.7028 23.5104 14.772 24.0518 18.1336 24.2389"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.2939 6.46143H15.9542V14.2341H12.2939"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.2939 10.3508H15.9542"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22.4928 6.46143H18.5593V14.2341H22.4928V10.3511H18.5593"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M29.057 6.46143H25.0981V14.2341H29.057V6.46143Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M31.7259 4.6235C32.498 4.6235 33.1239 3.96521 33.1239 3.15318C33.1239 2.34114 32.498 1.68286 31.7259 1.68286C30.9538 1.68286 30.3279 2.34114 30.3279 3.15318C30.3279 3.96521 30.9538 4.6235 31.7259 4.6235Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  }
  @if (isScreenShot) {
    <div>
      <button
        class="w-6 h-6 lg:w-10 lg:h-10 rounded-full p-0.5 lg:p-1.5 text-black/50 dark:text-white/50 hover:text-black/80 dark:hover:text-white/80"
        (click)="captureAllAngles()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 30" fill="none">
          <path
            d="M21.0271 3.84277H31.8917C33.1283 3.84277 34.129 4.8953 34.129 6.19584V22.994C34.129 24.2945 33.1283 25.3591 31.8917 25.3591H3.60012C2.3693 25.3591 1.36279 24.3005 1.36279 22.994V6.20189C1.36279 4.90135 2.3693 3.84882 3.60012 3.84882H8.92025"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.9713 21.0584C20.1076 21.0584 24.2715 16.6791 24.2715 11.2771C24.2715 5.87507 20.1076 1.49585 14.9713 1.49585C9.83496 1.49585 5.67114 5.87507 5.67114 11.2771C5.67114 16.6791 9.83496 21.0584 14.9713 21.0584Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M30.6211 1.48975H23.2131V3.84281H30.6211V1.48975Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M31.2537 25.365H4.31372V25.9578C4.31372 27.1494 5.23396 28.1173 6.367 28.1173H29.2004C30.3335 28.1173 31.2537 27.1494 31.2537 25.9578V25.365Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M34.1294 9.35962H30.2702C29.6605 9.35962 29.1716 9.87983 29.1716 10.515V18.6932C29.1716 19.3344 29.6663 19.8486 30.2702 19.8486H34.1294"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22.9771 16.2556H29.1714"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.96512 16.2556H1.35742"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.9712 18.5541C18.7734 18.5541 21.8557 15.3123 21.8557 11.3134C21.8557 7.31451 18.7734 4.07275 14.9712 4.07275C11.169 4.07275 8.08667 7.31451 8.08667 11.3134C8.08667 15.3123 11.169 18.5541 14.9712 18.5541Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  }

  @if (isTheme) {
    <div>
      <button
        class="w-6 h-6 lg:w-10 lg:h-10 rounded-full p-0.5 lg:p-1.5 text-black/50 dark:text-white/50 hover:text-black/80 dark:hover:text-white/80"
        (click)="onClickTheme()"
      >
        @if (theme == 'light') {
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
            <path
              d="M480-120q-150 0-255-105T120-480q0-150 105-255t255-105q14 0 27.5 1t26.5 3q-41 29-65.5 75.5T444-660q0 90 63 153t153 63q55 0 101-24.5t75-65.5q2 13 3 26.5t1 27.5q0 150-105 255T480-120Zm0-80q88 0 158-48.5T740-375q-20 5-40 8t-40 3q-123 0-209.5-86.5T364-660q0-20 3-40t8-40q-78 32-126.5 102T200-480q0 116 82 198t198 82Zm-10-270Z"
            />
          </svg>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
            <path
              d="M480-360q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Zm0 80q-83 0-141.5-58.5T280-480q0-83 58.5-141.5T480-680q83 0 141.5 58.5T680-480q0 83-58.5 141.5T480-280ZM200-440H40v-80h160v80Zm720 0H760v-80h160v80ZM440-760v-160h80v160h-80Zm0 720v-160h80v160h-80ZM256-650l-101-97 57-59 96 100-52 56Zm492 496-97-101 53-55 101 97-57 59Zm-98-550 97-101 59 57-100 96-56-52ZM154-212l101-97 55 53-97 101-59-57Zm326-268Z"
            />
          </svg>
        }
      </button>
    </div>
  }

  @if (isFullScreen) {
    @if (isFull) {
      <div>
        <button
          class="w-6 h-6 lg:w-10 lg:h-10 rounded-full p-0.5 lg:p-1.5 text-black/50 dark:text-white/50 hover:text-black/80 dark:hover:text-white/80"
          (click)="exitFullscreen()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#e3e3e3">
            <path
              d="M240-120v-120H120v-80h200v200h-80Zm400 0v-200h200v80H720v120h-80ZM120-640v-80h120v-120h80v200H120Zm520 0v-200h80v120h120v80H640Z"
            />
          </svg>
        </button>
      </div>
    } @else {
      <div>
        <button
          class="w-6 h-6 lg:w-10 lg:h-10 rounded-full p-0.5 lg:p-1.5 text-black/50 dark:text-white/50 hover:text-black/80 dark:hover:text-white/80"
          (click)="goFullScreen()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#e3e3e3">
            <path
              d="M120-120v-200h80v120h120v80H120Zm520 0v-80h120v-120h80v200H640ZM120-640v-200h200v80H200v120h-80Zm640 0v-120H640v-80h200v200h-80Z"
            />
          </svg>
        </button>
      </div>
    }
  }
  @if (isFirstCameraPosition) {
    <div>
      <button
        class="w-6 h-6 lg:w-10 lg:h-10 rounded-full p-0.5 lg:p-1.5 text-black/50 dark:text-white/50 hover:text-black/80 dark:hover:text-white/80"
        (click)="firstCameraSet()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
          <path
            d="M480-240q79 0 136-53.5T678-426l30 28 42-42-100-100-100 100 42 42 26-26q-6 53-45 88.5T480-300q-13 0-25.5-2.5T430-310l-44 44q22 12 45.5 19t48.5 7ZM310-340l100-100-42-42-26 26q6-53 45-88.5t93-35.5q13 0 25.5 2.5T530-570l44-44q-22-12-45.5-19t-48.5-7q-79 0-136 53.5T282-454l-30-28-42 42 100 100ZM160-120q-33 0-56.5-23.5T80-200v-480q0-33 23.5-56.5T160-760h126l74-80h240l74 80h126q33 0 56.5 23.5T880-680v480q0 33-23.5 56.5T800-120H160Zm0-80h640v-480H638l-73-80H395l-73 80H160v480Zm320-240Z"
          />
        </svg>
      </button>
    </div>
  }
</div>
